import { jsx } from "react/jsx-runtime";
import { Component } from "react";
import _ from "lodash";
import { interpolate } from "d3-interpolate";
const PropInterpolatorWrapper = (WrappedComponent) => {
  var _a;
  return _a = class extends Component {
    constructor() {
      super(...arguments);
      this.state = {
        interpolationFn: null,
        progress: 0,
        startTime: 0
      };
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
      const interpolationFn = (nextProps.customInterpolator || interpolate)(_.omit(this.props, this.props.excludeFromInterpolation), _.omit(nextProps, nextProps.excludeFromInterpolation));
      this.setState({
        interpolationFn,
        progress: 0,
        startTime: (/* @__PURE__ */ new Date()).getTime()
      });
    }
    componentDidUpdate() {
      if (!global.window.requestAnimationFrame) {
        this.setState({
          progress: 1
        });
      }
      global.window.requestAnimationFrame(() => {
        if (this.state.progress < 1) {
          const time = (/* @__PURE__ */ new Date()).getTime();
          let completion = (time - this.state.startTime) / this.props.transitionDuration;
          if (completion >= 1) {
            completion = 1;
          }
          this.setState({
            progress: this.props.easingFn(completion)
          });
        }
      });
    }
    render() {
      const excludedProps = _.pick(this.props, this.props.excludeFromInterpolation);
      let props = this.props;
      if (this.state.interpolationFn && this.state.progress < 1) {
        props = this.state.interpolationFn(this.state.progress);
      }
      return /* @__PURE__ */ jsx(WrappedComponent, { ...props, ...excludedProps });
    }
  }, _a.defaultProps = {
    excludeFromInterpolation: [],
    transitionDuration: 300,
    easingFn: (t) => t
    // linear
  }, _a;
};
export {
  PropInterpolatorWrapper as default
};
